module.exports = __webpack_public_path__ + "static/media/CTLA_5-216w.af58df1e.jpg";